import { render, staticRenderFns } from "./SvgComfortZones.vue?vue&type=template&id=0d4f7a6b"
import script from "./SvgComfortZones.vue?vue&type=script&lang=js"
export * from "./SvgComfortZones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports